import { render } from "./FavouriteToggle.vue?vue&type=template&id=8b4f07da&scoped=true"
import script from "./FavouriteToggle.vue?vue&type=script&lang=js"
export * from "./FavouriteToggle.vue?vue&type=script&lang=js"

import "./FavouriteToggle.vue?vue&type=style&index=0&id=8b4f07da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4f07da"]])

export default __exports__